import "./Resources.module.css";
import Header from "@/reusable_sections/Header";
import MovingInsights from "./sections/MovingInsights";
import CommonQuestions from "./sections/CommonQuestions";
import QuickTips from "./sections/QuickTips";
import Footer from "@/reusable_sections/Footer";
export default function ResourcesPage() {
  return <div>
      <Header />
      <MovingInsights />
      <CommonQuestions />
      <QuickTips />
      <Footer />
    </div>;
}